// extracted by mini-css-extract-plugin
export var container = "layout-module--container--RoCXy";
export var header = "layout-module--header--aoaNz";
export var main = "layout-module--main--ay8oo";
export var footer = "layout-module--footer--lccGK";